import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorRightColumn" }
const _hoisted_2 = { class: "CampaignEditorOverviewBlock" }
const _hoisted_3 = { class: "CampaignEditorOverviewTitle" }
const _hoisted_4 = { class: "CampaignEditorOverviewSubtitle" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "CampaignEditorText CampaignEditorTextInformative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			'OverviewBlockWrapper'
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
        _createElementVNode("label", { class: "CampaignEditorInputLabel DropdownLabel" }, " Linked organisations ")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        (_ctx.linkedOrganisations.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.linkedOrganisations, (linkedOrganisation) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(linkedOrganisation.name) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_4, " (" + _toDisplayString(linkedOrganisation.id) + ") ", 1 /* TEXT */)
                ]),
                _createElementVNode("button", {
                  class: "HelperButton CampaignEditorOverviewButton",
                  onClick: ($event: any) => (_ctx.unlinkOrganisation(linkedOrganisation))
                }, [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Unlink ", -1 /* CACHED */),
                  _createElementVNode("i", { class: "CampaignEditorOverviewButtonIcon lnr-unlink" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_5)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, " No organisations have been linked to this campaign yet ")),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "WarningWidget WarningWidgetPrimary" }, [
          _createElementVNode("i", { class: "lnr-info WarningWidgetIcon" }),
          _createElementVNode("span", { class: "WarningWidgetOuterContentWrapper" }, " Keep in mind that sub-organisations which are linked to a campaign which already has a parent organisation linked will be automatically unlinked. ")
        ], -1 /* CACHED */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["isLoading"]))
}